import { defineComponent as _defineComponent } from 'vue'
import type { SnowplowContext } from '@/helpers/tracking/providers/snowplow-contexts';
import { OfferPresentationType, OfferPresentationTypes } from '@/interfaces/titles';

import { ModalHelper } from '@/helpers/modal-helper';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';

import ChipButton from '@/ui-components/ChipButton.vue';
import ChipButtons from '@/ui-components/ChipButtons.vue';
import CountrySwitcherModal from '@/components/buybox/country-switcher/CountrySwitcherModal.vue';

import { useLanguageStore, useUserStore } from '@/helpers/composables/useStores';
import { useI18n } from '@/helpers/composables/useI18n';
import { useRoute } from 'vue-router/composables';
import { computed, onMounted } from 'vue';
import { useBuyboxLoggedInExp } from '../experiments/BuyboxLoggedInExp/composables/useBuyboxLoggedInExp';


export default /*#__PURE__*/_defineComponent({
  __name: 'BuyBoxFilter',
  props: {
    isInModal: { type: Boolean },
    defaultPresentationType: { default: null },
    additionalContexts: { default: () => [] },
    isEpisodeBuybox: { type: Boolean },
    episodeBuyBoxPresentationType: { default: null }
  },
  emits: ["episodeFilterChange"],
  setup(__props: any, { emit: emits }: { emit: ({ (e: 'episodeFilterChange', presentationType: OfferPresentationType | null): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { isInModal?: boolean, defaultPresentationType: OfferPresentationType | null, additionalContexts: SnowplowContext[], isEpisodeBuybox?: boolean, episodeBuyBoxPresentationType: OfferPresentationType | null };





const { webLocale, countryEmoji } = useLanguageStore();
const { buyboxPresentationType, setBuyboxPresentationType } = useUserStore();

const { trackBuyboxLoggedInExp } = useBuyboxLoggedInExp();

const { tc } = useI18n();
const filterOptions = computed(() => [
	{
		label: tc('WEBAPP_QUALITY_BESTPRICE'),
		value: null,
		isQuality: false,
	},
	{
		label: tc('WEBAPP_BUYBOX_FREE_FILTER'),
		value: OfferPresentationType.FREE,
		isQuality: false,
	},
	...OfferPresentationTypes.filter(g => g.isQuality),
]);

function openCountrySwitcherModal() {
	ModalHelper.openModal(CountrySwitcherModal, { closable: true });
	TrackingHelper.trackEvent('userinteraction', { action: 'country_selector_clicked' }, props.additionalContexts);

	trackBuyboxLoggedInExp({
		action: 'click',
		label: 'country_selector_clicked',
	});
}

function handleFilterClick(payload: {
	presentationType: OfferPresentationType | null;
	additionalContexts?: SnowplowContext[];
}) {
	props.isEpisodeBuybox ? emits('episodeFilterChange', payload.presentationType) : setBuyboxPresentationType(payload);

	trackBuyboxLoggedInExp({
		action: 'click',
		label: `filter_${payload.presentationType}`,
	});
}

function isFilterActive(filterValue: OfferPresentationType | null) {
	return props.isEpisodeBuybox
		? filterValue === props.episodeBuyBoxPresentationType
		: filterValue === buyboxPresentationType.value;
}

const route = useRoute();
onMounted(() => {
	// for Apple TV+ search ads
	if (route.query.monetization_types === 'free') {
		return setBuyboxPresentationType({ presentationType: OfferPresentationType.FREE });
	}

	if (!props.defaultPresentationType) return;

	setBuyboxPresentationType({
		presentationType: props.defaultPresentationType,
		additionalContexts: props.additionalContexts,
	});
});

return { __sfc: true,props, emits, webLocale, countryEmoji, buyboxPresentationType, setBuyboxPresentationType, trackBuyboxLoggedInExp, tc, filterOptions, openCountrySwitcherModal, handleFilterClick, isFilterActive, route, ChipButton, ChipButtons }
}

})